import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';
import Helpers from "../Shared/Helpers";
import {BUCKET_URL, MAIN} from "../Shared/Consts";
import FooterComponent from "../Shared/Footer";
import HeaderComponent from "../Shared/Header";

import ico_correct from '../assets/images/correct.png';
import ico_wrong from '../assets/images/wrong.png';
import queryString from "query-string";
import DialogBox from "../Shared/DialogBox";

class PNManual extends Component {

    constructor(props) {
        super(props);
        this.state = {
            testId:null,
            userId:null,
            numberCorrect: null,
            guid:require('uuid/v4')(),
            responseContent: null,
            modalDialog: false,
            return:false
        };

        this.submitPNManualSessionGrade = this.submitPNManualSessionGrade.bind(this);
        this.handleNumberCorrect = this.handleNumberCorrect.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount= async() => {
        Helpers.authorize(this);
        const parsed = queryString.parse(this.props.location.search);
        if(parsed.testId) {
            await REST.getPNManualScore(parsed.testId).then((response) => {
                this.setState({
                    testId: parsed.testId,
                    userId: parsed.userId,
                    numberCorrect:response.body.numberCorrect
                });
            });
        }else{
            this.setState({userId: parsed.userId});
        }
    };

    handleNumberCorrect(event){
        this.setState({numberCorrect:event.target.value});
    }

    handleDelete= async() =>{
        await REST.deletePictureNamingScore(this.state.testId);
        await this.setState({
            modalDialog: true,
            responseContent:"The score has been removed."
        });
    }

    handleCloseModal(){
        this.setState({modalDialog:false});
        if (this.state.return){
            this.props.history.goBack();
        }
    }

    submitPNManualSessionGrade = async()=> {
        if (this.state.numberCorrect >= 0 && this.state.numberCorrect <= 20) {
            await REST.gradePNManualSession({
                testId: this.state.testId,
                userId: this.state.userId,
                numberCorrect: this.state.numberCorrect
            });
            await this.setState({
                return: true,
                modalDialog: true,
                responseContent: "The Manual Session has been successfully saved."
            });
        } else {
            await this.setState({
                return: false,
                modalDialog: true,
                responseContent: "The number of correct answers needs to be between 0 and 20."
            });
        }
    };

    render() {

        return (
            <div>
                <HeaderComponent {...this.props}/>
                <div className={"section bgGrey"}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={this.handleCloseModal} />
                                <div className="col-lg-12 noPadding mobileCenter">
                                    <div className="col-sm-8"><h1>Picture Cards</h1></div>
                                    <div className="col-sm-4 tr">
                                        <a href={"https://docs.google.com/document/d/1WfKun_KlpgXcU63LaRN73gKIpBt5IeLKZSLmwmLKOjA"} className="handBtn" style={{ textDecoration: 'none', marginTop: -10 }} target="_blank"><span>Help Doc</span></a>

                                    </div>
                                    <div className="clearfix"></div>
                                    <hr/>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-lg-12 solidBorder">
                                    <div className="col-lg-12">
                                        <div className ="col-lg-4"></div>
                                        <div className="col-lg-4">
                                            <div className={"form-group"}>
                                                <a href={"https://uploadbeta.s3.us-east-2.amazonaws.com/documents/PN_Manual_images.pdf"} target="_blank" download="PNManualTask.pdf" className="handBtn" style={{marginRight:0}}>
                                                    <span>Download Picture Cards</span>
                                                </a>
                                            </div>
                                            <form>
                                                <label>Number of correct answers</label>
                                                <br/>
                                                <input type="text" onChange={this.handleNumberCorrect} value={this.state.numberCorrect?this.state.numberCorrect:null} id="inputCorrects" className="form-control " placeholder="" required autoFocus />
                                                <br/>
                                            </form>
                                        </div>
                                        <div className ="col-lg-4"></div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 paddingTop">
                            <div className="divBottomRelative tr">
                                <a onClick={()=>this.props.history.goBack()} className="handBtn fl"><span>Exit</span></a>
                                {this.state.testId?
                                <a onClick={this.handleDelete} className="handBtn"><span>Delete</span></a>:null
                                }
                                <a onClick={this.submitPNManualSessionGrade} className="handBtn"><span>Save</span></a>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );

    }
}

export default withRouter(PNManual);



// WEBPACK FOOTER //
// ./src/TeachersComponent/PNManual.js